import { makeAutoObservable } from 'mobx';
import IRecentItem, { RecentItemType } from '../interfaces/IRecentItem';
import IRecentSearch from '../interfaces/IRecentSearch';
import SearchType from '../interfaces/SearchType';
import LocalStorageService from '../services/localStorageService';
import { distinctBy } from '../utils/utils';

export default class RecentStore {
    private userEmail: string | null = null;
    recentSearches: IRecentSearch[] = [];
    recentItems: IRecentItem[] = [];

    constructor(
        private localStorageService: LocalStorageService,
    ) {
        makeAutoObservable(this);
    }

    initialize() {
        this.userEmail = this.localStorageService.getUserEmail()!;
        this.recentSearches = this.localStorageService.getRecentSearches(this.userEmail) || [];
        this.recentItems = this.localStorageService.getRecentItems(this.userEmail) || [];
    }

    addRecentSearch(query: string, type: SearchType) {
        this.recentSearches = distinctBy([
            { query, type },
            ...this.recentSearches,
        ], rs => `${rs.query}-${rs.type}`).slice(0, 5);

        this.localStorageService.setRecentSearches(this.userEmail!, this.recentSearches);
    }

    addRecentItem(id: number, type: RecentItemType) {
        this.recentItems = distinctBy([
            { id, type },
            ...this.recentItems,
        ], ri => `${ri.id}-${ri.type}`).slice(0, 5);

        this.localStorageService.setRecentItems(this.userEmail!, this.recentItems);
    }

    clear() {
        this.userEmail = null;
        this.recentSearches = [];
        this.recentItems = [];
    }
}